jQuery(function($) {
    'use strict';

    var AppSlick = function() {
        this.responsive_two = [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ];

        this.responsive_three = [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ];

        this.tab_scroll_distance = 24;
    }

    AppSlick.prototype.init = function() {
        $('.slideshow').each(function() {
            var adaptiveHeight = $(this).data('slickAdaptiveHeight') ?? 1;
            var arrows = $(this).data('slickArrows') ?? 1;
            var autoplay = $(this).data('slickAutoplay') ?? 0;
            var columns = $(this).data('slickColumns') ?? 2;
            var dots = $(this).data('slickDots') ?? 1;
            var fade = $(this).data('slickFade') ?? 0;
            var swipe = $(this).data('slickSwipe') ?? 1;

            var responsive = [];

            if(columns == 2) {
                responsive = $.AppSlick.responsive_two;
            } else if(columns >= 3) {
                responsive = $.AppSlick.responsive_three;
            }

            var options = {
                adaptiveHeight: !!adaptiveHeight,
                arrows: !!arrows,
                autoplay: !!autoplay,
                autoplaySpeed: 5000,
                dots: !!dots,
                fade: !!fade,
                responsive: responsive,
                slidesToShow: columns,
                speed: 250,
                swipe: !!swipe,
            };

            if(dots) {
                $(this).addClass('has-dots');
            }

            $(this).slick(options);
        });

        $(document).on('click', '.btn-slideshow-tab', function() {
            var buttons = $(this).closest('.slideshow-tabs-wrapper').find('.slideshow-tabs-buttons').find('.btn-slideshow-tab');
            var slideshow = $('.slideshow-tabs');

            var int = $(this).data('tabInt');

            slideshow.slick('goTo', int - 1);

            buttons.removeClass('btn-primary').addClass('btn-outline-primary');
            $(this).removeClass('btn-outline-primary').addClass('btn-primary');
        }).on('click', '.btn-jumpers-arrow', function() {
            $(this).closest('.btn-jumpers-wrapper').find('.btn-jumpers').animate({
                scrollLeft: $.AppSlick.tab_scroll_distance * 2,
            }, 500);
        });

        $('.btn-jumpers').scroll(function() {
            if($(this).scrollLeft() >= $.AppSlick.tab_scroll_distance) {
                $(this).closest('.btn-jumpers-wrapper').addClass('scrolled');
            }
        });
    }

    $.AppSlick = new AppSlick;
    $.AppSlick.Constructor = AppSlick;
});

jQuery(function($) {
    'use strict';

    $.AppSlick.init();
});
